import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { GetPOTimingLogsRequest, GetPOTimingLogsResponse } from 'src/types/edi';
import axiosInstance from 'src/utils/axios';

export function buildPOTimingLogsRequest(): GetPOTimingLogsRequest {
  return {
    clientSide: true,
    skip: 0,
    take: 0,
    skipCalculatingTotalRecordsCount: false,
    sort: [],
    filters: [],
  };
}

export interface UsePOTimingLogsQueryParams {
  enabled?: boolean;
}

const usePOTimingLogsQuery = ({ enabled = true }: UsePOTimingLogsQueryParams = {}) => {
  const [lastRequestedAt, setLastRequestedAt] = useState(0);

  const query = useQuery<GetPOTimingLogsResponse>({
    queryKey: queryKeys.ediAdmin.poTimingLogs(),
    enabled,
    queryFn: async () => {
      setLastRequestedAt(Date.now());
      const res = await axiosInstance.post<GetPOTimingLogsResponse>(
        api.getPOTimingLogs,
        buildPOTimingLogsRequest()
      );
      return res.data;
    },
  });

  return {
    ...query,
    lastRequestedAt,
  };
};

export default usePOTimingLogsQuery;
